import React from 'react';

const ExportIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#clip0_2280_52347)">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 2C12.4602 2 12.8333 2.3731 12.8333 2.83333V12.5967L15.0459 10.5543C15.3841 10.2422 15.9113 10.2632 16.2234 10.6014C16.5356 10.9396 16.5145 11.4668 16.1763 11.779L12.5652 15.1123C12.246 15.407 11.754 15.407 11.4348 15.1123L7.82366 11.779C7.48547 11.4668 7.46438 10.9396 7.77655 10.6014C8.08872 10.2632 8.61594 10.2422 8.95412 10.5543L11.1667 12.5967V2.83333C11.1667 2.3731 11.5398 2 12 2ZM2.83333 15.3333C3.29357 15.3333 3.66667 15.7064 3.66667 16.1667V18.9444C3.66667 19.7115 4.28849 20.3333 5.05556 20.3333H18.9444C19.7115 20.3333 20.3333 19.7115 20.3333 18.9444V16.1667C20.3333 15.7064 20.7064 15.3333 21.1667 15.3333C21.6269 15.3333 22 15.7064 22 16.1667V18.9444C22 20.632 20.632 22 18.9444 22H5.05556C3.36802 22 2 20.632 2 18.9444V16.1667C2 15.7064 2.3731 15.3333 2.83333 15.3333Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_2280_52347">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>

);

export default ExportIcon;
